<div class="non-printable-area connect-common-page-header">
    <div class="row">
        <div class="col-12 padding-top-10">
            <button mat-raised-button color="white" (click)="print()" class="float-right">
                <span class="padding-right-5">Print</span>
                <mat-icon>print</mat-icon>
            </button>
        </div>

    </div>

</div>
<div class="printable-area">
    <span class="header-details"><i class="fa fa-info-circle padding-right-5"></i>
        Please review the entered information for accuracy prior to submitting. The “Submit” button is located at the bottom of this page. Please note that all required information must be completed in order to submit. If any required information is missing, an “x” will appear next to that section within the menu. Please note that if you are missing any of the required information for a particular client, you can select the “I do not have all details for this client” checkbox under that client’s “Personal Details”.
    </span>

    <!-- Begin Client(s) Information -->
    <div *ngIf="cirfClients?.length">
        <div *ngFor="let client of cirfClients; let i=index">
            <div class="section-title">
                <span *ngIf="cirfClients?.length == 1">Client Profile</span>
                <span *ngIf="cirfClients?.length > 1">Client({{i+1}}) Profile</span>

            </div>
            <hr>
            <div class="items">
                <div class="item" [dp-field-visibility]="'cirfClientInfo.firstName'">
                    <div class="item-left">First Name:</div>
                    <div class="item-right">{{client.firstName}}</div>
                </div>
                <div class="item" [dp-field-visibility]="'cirfClientInfo.middleName'">
                    <div class="item-left">Middle Name:</div>
                    <div class="item-right">{{client.middleName}}</div>
                </div>
                <div class="item" [dp-field-visibility]="'cirfClientInfo.lastName'">
                    <div class="item-left">Last Name:</div>
                    <div class="item-right">{{client.lastName}}</div>
                </div>
                <div class="item" [dp-field-visibility]="'cirfClientInfo.gender'">
                    <div class="item-left">Gender:</div>
                    <div class="item-right">{{getLabelFromValue(client.gender, genderOptions)}}</div>
                </div>
                <div class="item" [dp-field-visibility]="'cirfClientInfo.birthDate'">
                    <div class="item-left">Birth Date:</div>
                    <div class="item-right">{{client.birthDate | date : 'mediumDate'}}</div>
                </div>
                <div class="item" [dp-field-visibility]="'cirfClientInfo.email'">
                    <div class="item-left">Email:</div>
                    <div class="item-right">{{client.email}}</div>
                </div>
                <ng-container *ngIf="cirf?.isMatterPurchase()" >
                    <div class="item" [dp-field-visibility]="'cirfClientInfo.firstTimeHomeBuyer'">
                        <div class="item-left">Are you a first time home owner?:</div>
                        <div class="item-right">{{getLabelFromValue(client.firstTimeHomeBuyer, firstTimeHomeBuyerOptions)}}</div>
                    </div>
                </ng-container>
                <div class="item" [dp-field-visibility]="'cirfClientInfo.isCanadianResident'">
                    <div class="item-left">Canadian Resident:</div>
                    <div class="item-right">{{getLabelFromValue(client.isCanadianResident, yesNoOptions)}}</div>
                </div>
                <ng-container *ngIf="client.isCanadianResidentYes()" >
                    <div class="item" [dp-field-visibility]="'cirfClientInfo.residentStatus'">
                        <div class="item-left">Resident Status:</div>
                        <div class="item-right">{{getLabelFromValue(client.residentStatus,residentStatusOptions)}}</div>
                    </div>
                </ng-container>
                <div class="item" *ngIf="client.isCanadianResidentYes() && getPermanentResidentCard(client.id)">
                    <div class="item-left">Permanent Resident Card:</div>
                    <div class="item-right">{{getPermanentResidentCard(client.id).documentName}} - {{getPermanentResidentCard(client.id).description}}</div>
                </div>
                <ng-container *ngIf="cirf && !cirf.isParticipantCirf() && !cirf.isCustomMatter()">
                    <div class="item" [dp-field-visibility]="'cirfClientInfo.spousalStatus'">
                        <div class="item-left">What is your spousal status?:</div>
                        <div class="item-right">{{getLabelFromValue(client.spousalStatus, spousalStatusOptions)}}</div>
                    </div>
                    <ng-container *ngIf="client.isSpousalStatusMarried()" >
                        <div class="item" [dp-field-visibility]="'cirfClientInfo.isFamilyResidence'">
                            <div class="item-left">Is this the family residence?:</div>
                            <div class="item-right">{{getLabelFromValue(client.isFamilyResidence, yesNoOptionsMandatory)}}</div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="client.isSpousalStatusMarried()" >
                        <div class="item" [dp-field-visibility]="'cirfClientInfo.isSpouseOnTitle'">
                            <div class="item-left">Is spouse on title?:</div>
                            <div class="item-right">{{getLabelFromValue(client.isSpouseOnTitle, yesNoOptionsMandatory) }}</div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="client.isSpouseNameVisible()" >
                        <div class="item" [dp-field-visibility]="'cirfClientInfo.spouseName'">
                            <div class="item-left">Spouse Name:</div>
                            <div class="item-right">{{client.spouseName}}</div>
                        </div>
                    </ng-container>

                </ng-container>

                <div class="item" [dp-field-visibility]="'cirfClientInfo.phone1.telephoneNumber'">
                    <div class="item-left">Home phone number:</div>
                    <div class="item-right">{{client.homePhone}}</div>
                </div>
                <div class="item" [dp-field-visibility]="'cirfClientInfo.phone2.telephoneNumber'">
                    <div class="item-left">Mobile phone number:</div>
                    <div class="item-right">{{client.cellPhone}}</div>
                </div>
                <div class="item" [dp-field-visibility]="'cirfClientInfo.phone3.telephoneNumber'">
                    <div class="item-left">Work phone number:</div>
                    <div class="item-right">{{client.workPhone}}</div>
                </div>
                <div class="item" [dp-field-visibility]="'cirfClientInfo.occupation'">
                    <div class="item-left">Occupation:</div>
                    <div class="item-right">{{client.occupation}}</div>
                </div>
            </div>
            <div class="items">
                <ng-container *ngFor="let udf of client.cirfClientInfoUdfs; let j=index">
                    <div class="item" [dp-field-visibility]="cirfClientInfoUdf+j" [isUdf]="true">
                        <div class="item-left" >{{udf.fieldLabel}}:</div>
                        <div class="item-right">{{udf.fieldValue}}</div>
                    </div>
                </ng-container>
            </div>
            <div>
                <div class="sub-header">
                    (Primary) Address
                </div>
                <div class="sub-header-ruler"><hr></div>
                <div class="items">
                    <div class="item" [dp-field-visibility]="'cirfClientInfo.address1.addressLine1'">
                        <div class="item-left">Address Line1:</div>
                        <div class="item-right">{{client.businessAddress?.addressLine1}}</div>
                    </div>
                    <div class="item" [dp-field-visibility]="'cirfClientInfo.address1.addressLine2'">
                        <div class="item-left">Address Line2:</div>
                        <div class="item-right">{{client.businessAddress?.addressLine2}}</div>
                    </div>
                    <div class="item" [dp-field-visibility]="'cirfClientInfo.address1.city'">
                        <div class="item-left">City:</div>
                        <div class="item-right">{{client.businessAddress?.city}}</div>
                    </div>
                    <div class="item" [dp-field-visibility]="'cirfClientInfo.address1.provinceCode'">
                        <div class="item-left">Province:</div>
                        <div class="item-right">{{client.businessAddress?.provinceCode}}</div>
                    </div>
                    <div class="item" [dp-field-visibility]="'cirfClientInfo.address1.postalCode'">
                        <div class="item-left">Postal Code:</div>
                        <div class="item-right">{{client.businessAddress?.postalCode}}</div>
                    </div>
                    <div class="item" [dp-field-visibility]="'cirfClientInfo.address1.country'">
                        <div class="item-left">Country:</div>
                        <div class="item-right">{{client.businessAddress?.country}}</div>
                    </div>
                </div>
            </div>

            <div>
                <div class="sub-header">
                    Primary Identification
                </div>
                <div class="sub-header-ruler"><hr></div>
                <div class="items">
                    <div class="item" [dp-field-visibility]="'cirfClientInfo.identification1.identificationTypeCode'">
                        <div class="item-left">Type of ID:</div>
                        <div class="item-right">{{client.identifications[0]?.identificationTypeCode}}</div>
                    </div>
                    <div class="item" [dp-field-visibility]="'cirfClientInfo.identification1.identificationNumber'">
                        <div class="item-left">Number:</div>
                        <div class="item-right">{{client.identifications[0]?.identificationNumber}}</div>
                    </div>
                    <div class="item" [dp-field-visibility]="'cirfClientInfo.identification1.placeOfIssue'">
                        <div class="item-left">Place of Issue:</div>
                        <div class="item-right">{{client.identifications[0]?.placeOfIssue}}</div>
                    </div>
                    <div class="item" [dp-field-visibility]="'cirfClientInfo.identification1.expiryDate'">
                        <div class="item-left">Expiry Date:</div>
                        <div class="item-right">{{formatExpiryDate(client.identifications[0]?.expiryDate)}}</div>
                    </div>
                    <div class="item" [dp-field-visibility]="'cirfClientInfo.identification1.country'">
                        <div class="item-left">Country:</div>
                        <div class="item-right">{{client.identifications[0]?.country}}</div>
                    </div>
                    <ng-container *ngFor="let udf of client.identifications[0]?.identificationUdfs; let j=index">
                        <div class="item" [dp-field-visibility]="identification1Udf+j" [isUdf]="true">
                            <div class="item-left">{{udf.fieldLabel}}:</div>
                            <div class="item-right">{{udf.fieldValue}}</div>
                        </div>

                    </ng-container>
                    <div class="item" *ngIf="getUploadedDocument(client.identifications[0], frontText, client.id)">
                        <div class="item-left">Front of the {{client.identifications[0].identificationTypeCode}}:</div>
                        <div class="item-right">{{getUploadedDocument(client.identifications[0], frontText, client.id).documentName}} - {{getUploadedDocument(client.identifications[0], frontText, client.id).description}}</div>
                    </div>
                    <div class="item" *ngIf="getUploadedDocument(client.identifications[0], backText, client.id)">
                        <div class="item-left">Back of the {{client.identifications[0].identificationTypeCode}}:</div>
                        <div class="item-right">{{getUploadedDocument(client.identifications[0], backText, client.id).documentName}} - {{getUploadedDocument(client.identifications[0], backText, client.id).description}}</div>
                    </div>
                </div>
            </div>

            <div>
                <div class="sub-header">
                    Secondary Identification
                </div>
                <div class="sub-header-ruler"><hr></div>
                <div class="items">
                    <div class="item" [dp-field-visibility]="'cirfClientInfo.identification2.identificationTypeCode'">
                        <div class="item-left">Type of ID:</div>
                        <div class="item-right">{{client.identifications[1]?.identificationTypeCode}}</div>
                    </div>
                    <div class="item" [dp-field-visibility]="'cirfClientInfo.identification2.identificationNumber'">
                        <div class="item-left">Number:</div>
                        <div class="item-right">{{client.identifications[1]?.identificationNumber}}</div>
                    </div>
                    <div class="item" [dp-field-visibility]="'cirfClientInfo.identification2.placeOfIssue'">
                        <div class="item-left">Place of Issue:</div>
                        <div class="item-right">{{client.identifications[1]?.placeOfIssue}}</div>
                    </div>
                    <div class="item" [dp-field-visibility]="'cirfClientInfo.identification2.expiryDate'">
                        <div class="item-left">Expiry Date:</div>
                        <div class="item-right">{{formatExpiryDate(client.identifications[1]?.expiryDate)}}</div>
                    </div>
                    <div class="item" [dp-field-visibility]="'cirfClientInfo.identification2.country'">
                        <div class="item-left">Country:</div>
                        <div class="item-right">{{client.identifications[1]?.country}}</div>
                    </div>
                    <ng-container *ngFor="let udf of client.identifications[1]?.identificationUdfs; let j=index">
                        <div class="item" [dp-field-visibility]="identification2Udf+j" [isUdf]="true">
                            <div class="item-left">{{udf.fieldLabel}}:</div>
                            <div class="item-right">{{udf.fieldValue}}</div>
                        </div>
                    </ng-container>
                    <div class="item" *ngIf="getUploadedDocument(client.identifications[1], frontText, client.id)">
                        <div class="item-left">Front of the {{client.identifications[1].identificationTypeCode}}:</div>
                        <div class="item-right">{{getUploadedDocument(client.identifications[1], frontText, client.id).documentName}} - {{getUploadedDocument(client.identifications[1], frontText, client.id).description}}</div>
                    </div>
                    <div class="item" *ngIf="getUploadedDocument(client.identifications[1], backText, client.id)">
                        <div class="item-left">Back of the {{client.identifications[1].identificationTypeCode}}:</div>
                        <div class="item-right">{{getUploadedDocument(client.identifications[1], backText, client.id).documentName}} - {{getUploadedDocument(client.identifications[1], backText, client.id).description}}</div>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <ng-container *ngIf="cirf?.cirfMatterData?.clientNotes">
            <div [dp-field-visibility]="'cirfClientInfo.clientNotes'">
                <div class="section-title" >
                    <span *ngIf="cirfClients?.length == 1">Client Notes</span>
                    <span *ngIf="cirfClients?.length > 1">Client(s) Notes</span>
                </div>
                <hr>
                <div class="items">
                    <div class="item">
                        <div class="item-left"></div>
                        <div class="item-right notes" [innerHtml]="cirf?.cirfMatterData?.clientNotes"></div>
                    </div>
                </div>
                <hr>
            </div>
        </ng-container>
    </div>
    <!-- EndClient(s) Information -->

    <!-- Begin Property Information -->
    <div  *ngIf="cirf?.isMatterCirf() && !isCustomMatter()">
        <div class="section-title">
            <span>Transaction Details</span>
        </div>
        <hr>
        <div class="items">
            <ng-container *ngIf="cirf?.isMatterPurchase()" >
                <div class="item" [dp-field-visibility]="'matterContactInfo.clientCapacity'">
                    <div class="item-left"
                         [dp-province-field-label]="'cirfMatterData.capacity'"
                         [label-province-code] = "cirf?.provinceCode">Capacity:</div>
                    <div class="item-right">{{getLabelFromValue(matterContactInfo?.clientCapacity, matterPurchasersCapacityOptions)}}</div>
                </div>
            </ng-container>

            <div class="item" [dp-field-visibility]="'matterContactInfo.residingAtSubjectProperty'">
                <div class="item-left">{{cirf?.isMatterSale() || cirf?.isMatterMortgage() ? 'Do you reside at the subject property?:': 'Will you be residing at the subject property?:'}}</div>
                <div class="item-right">{{getLabelFromValue(matterContactInfo?.residingAtSubjectProperty, yesNoOptionsMandatory)}}</div>
            </div>

            <div class="items" *ngFor="let udf of matterContactInfo.matterContactInfoUdfs; let i=index">
                <div class="item" [dp-field-visibility]="matterContactInfoUdf+i" [isUdf]="true">
                    <div class="item-left">{{udf.fieldLabel}}:</div>
                    <div class="item-right">{{udf.fieldValue}}</div>
                </div>

            </div>

            <div *ngIf="isClosingAddressVisible()">
                <div class="sub-header" >
                    {{closingAddress}}
                </div>
                <div class="sub-header-ruler"><hr></div>
                <div class="items">
                    <div class="item" [dp-field-visibility]="'matterContactInfo.address.addressLine1'">
                        <div class="item-left">Address Line1:</div>
                        <div class="item-right">{{preOrPostClosingAddress?.addressLine1}}</div>
                    </div>
                    <div class="item" [dp-field-visibility]="'matterContactInfo.address.addressLine2'">
                        <div class="item-left">Address Line2:</div>
                        <div class="item-right">{{preOrPostClosingAddress?.addressLine2}}</div>
                    </div>
                    <div class="item" [dp-field-visibility]="'matterContactInfo.address.city'">
                        <div class="item-left">City:</div>
                        <div class="item-right">{{preOrPostClosingAddress?.city}}</div>
                    </div>
                    <div class="item" [dp-field-visibility]="'matterContactInfo.address.provinceCode'">
                        <div class="item-left">Province:</div>
                        <div class="item-right">{{preOrPostClosingAddress?.provinceCode}}</div>
                    </div>
                    <div class="item" [dp-field-visibility]="'matterContactInfo.address.postalCode'">
                        <div class="item-left">Postal Code:</div>
                        <div class="item-right">{{preOrPostClosingAddress?.postalCode}}</div>
                    </div>
                    <div class="item" [dp-field-visibility]="'matterContactInfo.address.country'">
                        <div class="item-left">Country:</div>
                        <div class="item-right">{{preOrPostClosingAddress?.country}}</div>
                    </div>
                </div>

            </div>
            <div *ngIf="cirf && !cirf.isMatterSale()">
                <div class="sub-header" >
                    {{cirf?.isMatterPurchase()? 'New' : 'Existing'}} Insurance Details
                </div>
                <div class="sub-header-ruler"><hr></div>
                <div class="items">
                    <div class="item" [dp-field-visibility]="'fireInsuranceDetail.companyName'">
                        <div class="item-left">Name of Company:</div>
                        <div class="item-right">{{fireInsuranceDetail?.companyName}}</div>
                    </div>
                    <div class="item" [dp-field-visibility]="'fireInsuranceDetail.policyNumber'">
                        <div class="item-left">Policy No.:</div>
                        <div class="item-right">{{fireInsuranceDetail?.policyNumber}}</div>
                    </div>
                    <div class="item" [dp-field-visibility]="'fireInsuranceDetail.broker.name'">
                        <div class="item-left">Name of Broker:</div>
                        <div class="item-right">{{fireInsuranceDetail?.insuranceBroker?.name}}</div>
                    </div>
                    <div class="item" [dp-field-visibility]="'fireInsuranceBroker.phone1.telephoneNumber'">
                        <div class="item-left">Phone Number:</div>
                        <div class="item-right">{{fireInsuranceDetail?.insuranceBroker?.workPhone}}</div>
                    </div>
                    <div class="item" [dp-field-visibility]="'fireInsuranceDetail.broker.email'">
                        <div class="item-left">Email:</div>
                        <div class="item-right">{{fireInsuranceDetail?.insuranceBroker?.email}}</div>
                    </div>
                    <div class="item" [dp-field-visibility]="'insuranceNotes'" >
                        <div class="item-left">Fire Insurance Notes</div>
                        <div class="item-right notes" [innerHtml]="cirf?.cirfMatterData?.insuranceNotes"></div>
                    </div>
                </div>
                <div class="items" *ngFor="let udf of fireInsuranceDetail.insuranceUdfs; let i=index">
                    <div [dp-field-visibility]="fireInsuranceDetailUdf+i" [isUdf]="true">
                        <div class="item-left">{{udf.fieldLabel}}:</div>
                        <div class="item-right">{{udf.fieldValue}}</div>
                    </div>
                </div>
            </div>
        </div>
        <hr>
    </div>

    <!-- End Property Information -->

    <!-- Begin Matter Notes -->
    <div *ngIf="cirf?.cirfMatterData?.matterNotes">
        <div class="section-title" [dp-field-visibility]="'matterNotes'">
            <span>General Matter Notes</span>
        </div>
        <hr>
        <div class="items">
            <div class="item" [dp-field-visibility]="'matterNotes'">
                <div class="item-left"></div>
                <div class="item-right notes" [innerHtml]="cirf?.cirfMatterData?.matterNotes"></div>
            </div>
        </div>
        <hr>
    </div>
    <!-- End Matter Notes -->

    <!-- Begin General Attachments -->
    <div *ngIf="getGeneralDocuments()?.length">
        <div class="section-title">
            <span>Attachments</span>
        </div>
        <hr>
        <div class="items">
            <div class="item" *ngFor="let document of getGeneralDocuments()">
                <div class="item-left"></div>
                <div class="item-right">{{document.documentName}} - {{document.description}}</div>
            </div>
        </div>
        <hr>
    </div>
    <!-- End General Attachments -->

    <!-- Begin New Mortgage Information -->
    <div *ngIf="newMortgages?.length">
        <div *ngFor="let mortgage of newMortgages; let i=index">
            <div *ngIf="!mortgage.needCleanup">
                <div class="section-title">
                    <span *ngIf="newMortgages?.length == 1">New Mortgage Information</span>
                    <span *ngIf="newMortgages?.length > 1">New Mortgage #{{i+1}} Information</span>
                </div>
                <hr>
                <div class="items">
                    <div class="item" [dp-field-visibility]="'newMortgage.bankName'">
                        <div class="item-left">Name of Bank</div>
                        <div class="item-right">{{mortgage.bankName}}</div>
                    </div>
                    <div class="item" [dp-field-visibility]="'newMortgage.referenceNumber'">
                        <div class="item-left">Reference No.</div>
                        <div class="item-right">{{mortgage.referenceNumber}}</div>
                    </div>
                    <ng-container *ngIf="mortgage.mortgageBroker">
                        <div class="item" [dp-field-visibility]="'newMortgage.broker.name'">
                            <div class="item-left">Name of Broker</div>
                            <div class="item-right">{{mortgage.mortgageBroker?.name}}</div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="mortgage.mortgageBroker" >
                        <div class="item" [dp-field-visibility]="'newMortgageBroker.phone1.telephoneNumber'">
                            <div class="item-left">Phone Number</div>
                            <div class="item-right">{{mortgage.mortgageBroker?.workPhone}}</div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="mortgage.mortgageBroker" >
                        <div class="item" [dp-field-visibility]="'newMortgage.broker.email'">
                            <div class="item-left">Email</div>
                            <div class="item-right">{{mortgage.mortgageBroker?.email}}</div>
                        </div>
                    </ng-container>

                    <ng-container *ngFor="let udf of mortgage.mortgageUdfs; let i=index">
                        <div class="item" [dp-field-visibility]="newMortgageUdf+i" [isUdf]="true">
                            <div class="item-left">{{udf.fieldLabel}}:</div>
                            <div class="item-right">{{udf.fieldValue}}</div>
                        </div>

                    </ng-container>
                </div>
            </div>
            <hr *ngIf="(newMortgages? newMortgages.length : 0) > cleanNewMortgageNumber">
        </div>
    </div>
    <div *ngIf="cirf?.cirfMatterData?.mortgageNotes">
        <div class="section-title">
            <span>New Mortgage Notes</span>
        </div>
        <hr>
        <div class="items" [dp-field-visibility]="'newMortgage.mortgageNotes'">
            <div class="item">
                <div class="item-left"></div>
                <div class="item-right notes" [innerHtml]="cirf?.cirfMatterData?.mortgageNotes"></div>
            </div>
        </div>
        <hr>
    </div>

    <!-- End New Mortgage Information -->

    <!-- Begin Existing Mortgage Information -->
    <div *ngIf="existingMortgages?.length > 0">
        <div *ngFor="let mortgage of existingMortgages; let i=index">
            <div *ngIf="!mortgage.needCleanup">
                <div class="section-title">
                    <span *ngIf="existingMortgages?.length == 1">Existing Mortgage Information</span>
                    <span *ngIf="existingMortgages?.length > 1">Existing Mortgage #{{i+1}} Information</span>
                </div>
                <hr>
                <div class="items">
                    <div class="item" [dp-field-visibility]="'existingMortgage.bankName'">
                        <div class="item-left">Name of Bank</div>
                        <div class="item-right">{{mortgage.bankName}}</div>
                    </div>
                    <div class="item" [dp-field-visibility]="'existingMortgage.referenceNumber'">
                        <div class="item-left">Reference No.</div>
                        <div class="item-right">{{mortgage.referenceNumber}}</div>
                    </div>
                    <ng-container *ngIf="mortgage.mortgageBroker" >
                        <div class="item" [dp-field-visibility]="'existingMortgage.broker.name'" >
                            <div class="item-left">Name of Broker</div>
                            <div class="item-right">{{mortgage.mortgageBroker?.name}}</div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="mortgage.mortgageBroker" >
                        <div class="item" [dp-field-visibility]="'existingMortgageBroker.phone1.telephoneNumber'">
                            <div class="item-left">Phone Number</div>
                            <div class="item-right">{{mortgage.mortgageBroker?.workPhone}}</div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="mortgage.mortgageBroker" >
                        <div class="item" [dp-field-visibility]="'existingMortgage.broker.email'">
                            <div class="item-left">Email</div>
                            <div class="item-right">{{mortgage.mortgageBroker?.email}}</div>
                        </div>
                    </ng-container>

                    <ng-container *ngFor="let udf of mortgage.mortgageUdfs">
                        <div class="item" [dp-field-visibility]="existingMortgageUdf+i" [isUdf]="true">
                            <div class="item-left">{{udf.fieldLabel}}:</div>
                            <div class="item-right">{{udf.fieldValue}}</div>
                        </div>
                    </ng-container>
                </div>
                <div *ngIf="getMortgageDocuments(mortgage.id)?.length">
                    <div class="sub-header" >
                        Mortgage Attachments
                    </div>
                    <div class="sub-header-ruler"><hr></div>
                    <div class="items">
                        <div class="item" *ngFor="let document of getMortgageDocuments(mortgage.id) ">
                            <div class="item-left"></div>
                            <div class="item-right">{{document.documentName}} - {{document.description}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr *ngIf="(existingMortgages? existingMortgages.length : 0) > cleanExistingMortgageNumber">
    </div>
    <div *ngIf="cirf?.cirfMatterData?.existingMortgageNotes">
        <div class="section-title">
            <span>Existing Mortgage Notes</span>
        </div>
        <hr>
        <div class="items" [dp-field-visibility]="'existingMortgage.mortgageNotes'">
            <div class="item">
                <div class="item-left"></div>
                <div class="item-right notes" [innerHtml]="cirf?.cirfMatterData?.existingMortgageNotes"></div>
            </div>
        </div>
    </div>


    <!-- End Existing Mortgage Information -->

</div>
